import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAddValueButton, LazyAlgorithmBlockAssignFunction, LazyAlgorithmBlockAssignValue, LazyAlgorithmBlockAssign, LazyAlgorithmBlockCondition, LazyAlgorithmBlockException, LazyAlgorithmBlockGoto, LazyAlgorithmBlockResult, LazyAlgorithmDialogSelectValue, LazyAlgorithmInput, LazyAlgorithmInputList, LazyAlgorithmObjectValue, LazyAlgorithm, LazyAlgorithmEditorBlockCommand, LazyAlgorithmEditorBlockCondition, LazyAlgorithmEditorBlockCycle, LazyAlgorithmEditorBlockException, LazyAlgorithmEditorBlockFunction, LazyAlgorithmEditorBlockGoto, LazyAlgorithmEditorBlockPolitic, LazyAlgorithmEditorBlockResult, LazyAlgorithmEditorBlockVariable, LazyAlgorithmEditorDialogContentSelectBlockType, LazyAlgorithmEditorDialogContentSelectCommandBlock, LazyAlgorithmEditorDialogContentSelectResult, LazyAlgorithmEditorDialogContentSelectValue, LazyAlgorithmEditorDialogSelectBlockType, LazyAlgorithmEditorDialogSelectCommandBlock, LazyAlgorithmEditorDialogSelectResult, LazyAlgorithmEditorDialogSelectValue, LazyAlgorithmEditorDialogWarningRemoveBlock, LazyAlgorithmEditorFunctionArgument, LazyAlgorithmEditorFunctionArgumentList, LazyAlgorithmEditorInput, LazyAlgorithmEditorInputList, LazyAlgorithmEditorInputVariable, LazyAlgorithmEditorObjectValue, LazyAlgorithmEditorPoliticArgument, LazyAlgorithmEditor, LazyAppHeader, LazyAppLeftMenu, LazyAppLogo, LazyBreadcrumbs, LazyCalculationStep, LazyCalculation, LazyCatalogPageControlFooter, LazyCatalogPageControl, LazyCommercialRuleFilterGroup, LazyCommercialRuleFilterGroupType, LazyCommercialRuleFilterParam, LazyCommercialRuleFilter, LazyConcurrentPricesItem, LazyConcurrentPrices, LazyConstellationAnchor, LazyConstellationBlock, LazyConstellationBlockMenu, LazyConstellationBorder, LazyConstellationConnector, LazyConstellationConnectorMenu, LazyConstellation, LazyCorrectionEditParam, LazyCorrectionGroupPrice, LazyCorrectionMainPage, LazyCorrectionMergeNotConflictParamPage, LazyCorrectionMergeNotConflictPricePage, LazyCorrectionMergeParamPage, LazyCorrectionMergePricePage, LazyCorrectionParamPage, LazyCorrectionPriceAddItems, LazyCorrectionPriceAddOne, LazyCorrectionPricePage, LazyCorrectionPriority, LazyCorrectionSelectControl, LazyCron, LazyDataTableFooter, LazyDatePicker, LazyDelValueButton, LazyDelayItemControl, LazyDelay, LazyDelayItem, LazyDialogActiveDialog, LazyDialogApplyPricesDialog, LazyDialogCorrectionPriceIntersectionDialog, LazyDialogDeleteDialog, LazyDialogErrorDialog, LazyDialogFixPriceIntersectionDialog, LazyDialogGroupTreeModal, LazyDialogPageDialogues, LazyDialogParamValueDialog, LazyDialogPriceDialog, LazyDialogSelectColumns, LazyDialogSelectParametersDialog, LazyDialogSelectPriceLevel, LazyDialogSelectPriceType, LazyDialogSelectRegionType, LazyDialogSelectStockLevel, LazyDialogSelectTable, LazyDialogTableValueDialog, LazyDialogUploadCorrectionPriceErrorDialog, LazyDialogUploadCorrectionPriceFinishDialog, LazyDialogWarningParameterHasValue, LazyDialogMarketingValueTypeDialog, LazyDialogParamValueBoolValue, LazyDialogParamValueDigitValue, LazyDialogParamValueStringValue, LazyDialogParamValueTableValue, LazyEventTypeSchemaEditorArrayItem, LazyEventTypeSchemaEditorItem, LazyEventTypeSchemaEditorObjectItem, LazyEventTypeSchemaEditorPanel, LazyEventTypeSchemaEditor, LazyFilterParam, LazyFlowChartBlockAnchor, LazyFlowChartBlockAnchorG, LazyFlowChartBlockBaseBlock, LazyFlowChartBlockBorder, LazyFlowChartBlockCondition, LazyFlowChartBlockException, LazyFlowChartBlockFinish, LazyFlowChartBlockFunction, LazyFlowChartBlockProcess, LazyFlowChartBlockResult, LazyFlowChartBlockStart, LazyFlowChartComponentButtonClear, LazyFlowChartComponentButtonSelect, LazyFlowChartComponentCompare, LazyFlowChartComponentFunction, LazyFlowChartComponentMessage, LazyFlowChartComponentVarName, LazyFlowChartComponentVarSource, LazyFlowChartConnector, LazyFlowChart, LazyFormEditor, LazyGroupList, LazyGroupTree, LazyGroupTreeSelect, LazyInputParameterValueBoolean, LazyInputParameterValueDataTable, LazyInputParameterValueDateTime, LazyInputParameterValueDigital, LazyInputParameterValueDigitalList, LazyInputParameterValueDigitalListBox, LazyInputParameterValuePriceLevel, LazyInputParameterValueVariable, LazyInputParameterValueInputParameterVariable, LazyInputParameterValueListBox, LazyInputParameterValuePrice, LazyInputParameterValueRegion, LazyInputParameterValueRegionPrice, LazyInputParameterValueStockLevel, LazyInputParameterValueString, LazyInputParameterValueStringList, LazyInputParameterValueTable, LazyInputParameterValue, LazyJsonEditor, LazyLeftMenuItem, LazyLinkButton, LazyLoyaltyAlgorithmEditorBlockResult, LazyLoyaltyAlgorithmEditorDialogSelectOutParam, LazyLoyaltyAlgorithmEditorDialogSelectValue, LazyMarketingAlgorithmEditorDialogSelectResult, LazyMarketingAlgorithmEditorDialogSelectValue, LazyMarketingConditionAlgorithmEditorDialogSelectValue, LazyPagesBaseTaskPage, LazyParamSearchPanel, LazyParamValuePanel, LazyParamValueProductPanel, LazyParameterTypeBoolean, LazyParameterTypeDecimal, LazyParameterTypeList, LazyParameterTypePercent, LazyParameterTypeString, LazyParameterTypeTable, LazyParameterValueTable, LazyPriceLevelRule, LazyPriceLevel, LazyPriceRegionGroupFilter, LazyProductDistributionRulesBlock, LazyProductDistributionRulesCondition, LazyProductDistributionRulesItem, LazyProductDistributionRules, LazyProviderRuleCondition, LazyProviderRuleDialogSelect, LazyProviderRuleGroup, LazyProviderRuleItem, LazyProviderRule, LazyResultEditorArrayItem, LazyResultEditorItem, LazyResultEditorObjectItem, LazyResultEditorPanel, LazyResultEditor, LazyRichTable, LazyRoomEditor, LazySearchControl, LazySearchFilterItem, LazySearchFilterPopover, LazySearchPanelFieldAllocationRule, LazySearchPanelFieldBoolean, LazySearchPanelFieldCardType, LazySearchPanelFieldCode, LazySearchPanelFieldConcurrent, LazySearchPanelFieldConcurrentPriceTypeName, LazySearchPanelFieldConcurrentProductStatus, LazySearchPanelFieldConcurrentProductStatusName, LazySearchPanelFieldConcurrentRegionName, LazySearchPanelFieldDate, LazySearchPanelFieldGroup, LazySearchPanelFieldGroupType, LazySearchPanelFieldID, LazySearchPanelFieldNumber, LazySearchPanelFieldParamType, LazySearchPanelFieldPolitic, LazySearchPanelFieldPriceType, LazySearchPanelFieldPriceTypeGroup, LazySearchPanelFieldProduct, LazySearchPanelFieldRegionGroup, LazySearchPanelFieldRegionType, LazySearchPanelFieldScope, LazySearchPanelFieldShop, LazySearchPanelFieldShowcase, LazySearchPanelFieldShowcaseCategory, LazySearchPanelFieldShowcaseModuleType, LazySearchPanelFieldShowcaseType, LazySearchPanelFieldShowcaseTypeModuleTemplate, LazySearchPanelFieldStock, LazySearchPanelFieldString, LazySearchPanelFieldSupplier, LazySearchPanelFieldUser, LazySearchPanelFilter, LazySearchPanel, LazyShowcasePlanogram, LazyShowсaseTemplateEditor, LazyStockLevelRule, LazyStockLevel, LazyStockSuppliersItem, LazyStockSuppliers, LazyTabButtonControl, LazyTabButtonPanel, LazyTabButton, LazyTask, LazyTaskEditor, LazyTimeSelectorPanel, LazyTimeSelectorConsts, LazyTimeSelector, LazyTitlePageControlFooter, LazyTitlePageControl, LazyTriggerMapping, LazyTriggerMappingItem, LazyValueField, LazyVariableEditorArrayItem, LazyVariableEditorItem, LazyVariableEditorObjectItem, LazyVariableEditorPanel, LazyVariableEditor, LazyVariableValuePanel, LazyTableValueListLimit, LazyTableValueRangeLimit, LazyTableValueWithoutLimit, LazyValueListItem, LazyValueListPanel, LazyUAccordion, LazyUAlert, LazyUAvatar, LazyUAvatarGroup, LazyUBadge, LazyUButton, LazyUButtonGroup, LazyUCarousel, LazyUChip, LazyUDropdown, LazyUIcon, LazyUKbd, LazyULink, LazyUMeter, LazyUMeterGroup, LazyUProgress, LazyUCheckbox, LazyUForm, LazyUFormGroup, LazyUInput, LazyUInputMenu, LazyURadio, LazyURadioGroup, LazyURange, LazyUSelect, LazyUSelectMenu, LazyUTextarea, LazyUToggle, LazyUTable, LazyUCard, LazyUContainer, LazyUDivider, LazyUSkeleton, LazyUBreadcrumb, LazyUCommandPalette, LazyUCommandPaletteGroup, LazyUHorizontalNavigation, LazyUPagination, LazyUTabs, LazyUVerticalNavigation, LazyUContextMenu, LazyUModal, LazyUModals, LazyUNotification, LazyUNotifications, LazyUPopover, LazyUSlideover, LazyUSlideovers, LazyUTooltip, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["AddValueButton", LazyAddValueButton],
["AlgorithmBlockAssignFunction", LazyAlgorithmBlockAssignFunction],
["AlgorithmBlockAssignValue", LazyAlgorithmBlockAssignValue],
["AlgorithmBlockAssign", LazyAlgorithmBlockAssign],
["AlgorithmBlockCondition", LazyAlgorithmBlockCondition],
["AlgorithmBlockException", LazyAlgorithmBlockException],
["AlgorithmBlockGoto", LazyAlgorithmBlockGoto],
["AlgorithmBlockResult", LazyAlgorithmBlockResult],
["AlgorithmDialogSelectValue", LazyAlgorithmDialogSelectValue],
["AlgorithmInput", LazyAlgorithmInput],
["AlgorithmInputList", LazyAlgorithmInputList],
["AlgorithmObjectValue", LazyAlgorithmObjectValue],
["Algorithm", LazyAlgorithm],
["AlgorithmEditorBlockCommand", LazyAlgorithmEditorBlockCommand],
["AlgorithmEditorBlockCondition", LazyAlgorithmEditorBlockCondition],
["AlgorithmEditorBlockCycle", LazyAlgorithmEditorBlockCycle],
["AlgorithmEditorBlockException", LazyAlgorithmEditorBlockException],
["AlgorithmEditorBlockFunction", LazyAlgorithmEditorBlockFunction],
["AlgorithmEditorBlockGoto", LazyAlgorithmEditorBlockGoto],
["AlgorithmEditorBlockPolitic", LazyAlgorithmEditorBlockPolitic],
["AlgorithmEditorBlockResult", LazyAlgorithmEditorBlockResult],
["AlgorithmEditorBlockVariable", LazyAlgorithmEditorBlockVariable],
["AlgorithmEditorDialogContentSelectBlockType", LazyAlgorithmEditorDialogContentSelectBlockType],
["AlgorithmEditorDialogContentSelectCommandBlock", LazyAlgorithmEditorDialogContentSelectCommandBlock],
["AlgorithmEditorDialogContentSelectResult", LazyAlgorithmEditorDialogContentSelectResult],
["AlgorithmEditorDialogContentSelectValue", LazyAlgorithmEditorDialogContentSelectValue],
["AlgorithmEditorDialogSelectBlockType", LazyAlgorithmEditorDialogSelectBlockType],
["AlgorithmEditorDialogSelectCommandBlock", LazyAlgorithmEditorDialogSelectCommandBlock],
["AlgorithmEditorDialogSelectResult", LazyAlgorithmEditorDialogSelectResult],
["AlgorithmEditorDialogSelectValue", LazyAlgorithmEditorDialogSelectValue],
["AlgorithmEditorDialogWarningRemoveBlock", LazyAlgorithmEditorDialogWarningRemoveBlock],
["AlgorithmEditorFunctionArgument", LazyAlgorithmEditorFunctionArgument],
["AlgorithmEditorFunctionArgumentList", LazyAlgorithmEditorFunctionArgumentList],
["AlgorithmEditorInput", LazyAlgorithmEditorInput],
["AlgorithmEditorInputList", LazyAlgorithmEditorInputList],
["AlgorithmEditorInputVariable", LazyAlgorithmEditorInputVariable],
["AlgorithmEditorObjectValue", LazyAlgorithmEditorObjectValue],
["AlgorithmEditorPoliticArgument", LazyAlgorithmEditorPoliticArgument],
["AlgorithmEditor", LazyAlgorithmEditor],
["AppHeader", LazyAppHeader],
["AppLeftMenu", LazyAppLeftMenu],
["AppLogo", LazyAppLogo],
["Breadcrumbs", LazyBreadcrumbs],
["CalculationStep", LazyCalculationStep],
["Calculation", LazyCalculation],
["CatalogPageControlFooter", LazyCatalogPageControlFooter],
["CatalogPageControl", LazyCatalogPageControl],
["CommercialRuleFilterGroup", LazyCommercialRuleFilterGroup],
["CommercialRuleFilterGroupType", LazyCommercialRuleFilterGroupType],
["CommercialRuleFilterParam", LazyCommercialRuleFilterParam],
["CommercialRuleFilter", LazyCommercialRuleFilter],
["ConcurrentPricesItem", LazyConcurrentPricesItem],
["ConcurrentPrices", LazyConcurrentPrices],
["ConstellationAnchor", LazyConstellationAnchor],
["ConstellationBlock", LazyConstellationBlock],
["ConstellationBlockMenu", LazyConstellationBlockMenu],
["ConstellationBorder", LazyConstellationBorder],
["ConstellationConnector", LazyConstellationConnector],
["ConstellationConnectorMenu", LazyConstellationConnectorMenu],
["Constellation", LazyConstellation],
["CorrectionEditParam", LazyCorrectionEditParam],
["CorrectionGroupPrice", LazyCorrectionGroupPrice],
["CorrectionMainPage", LazyCorrectionMainPage],
["CorrectionMergeNotConflictParamPage", LazyCorrectionMergeNotConflictParamPage],
["CorrectionMergeNotConflictPricePage", LazyCorrectionMergeNotConflictPricePage],
["CorrectionMergeParamPage", LazyCorrectionMergeParamPage],
["CorrectionMergePricePage", LazyCorrectionMergePricePage],
["CorrectionParamPage", LazyCorrectionParamPage],
["CorrectionPriceAddItems", LazyCorrectionPriceAddItems],
["CorrectionPriceAddOne", LazyCorrectionPriceAddOne],
["CorrectionPricePage", LazyCorrectionPricePage],
["CorrectionPriority", LazyCorrectionPriority],
["CorrectionSelectControl", LazyCorrectionSelectControl],
["Cron", LazyCron],
["DataTableFooter", LazyDataTableFooter],
["DatePicker", LazyDatePicker],
["DelValueButton", LazyDelValueButton],
["DelayItemControl", LazyDelayItemControl],
["Delay", LazyDelay],
["DelayItem", LazyDelayItem],
["DialogActiveDialog", LazyDialogActiveDialog],
["DialogApplyPricesDialog", LazyDialogApplyPricesDialog],
["DialogCorrectionPriceIntersectionDialog", LazyDialogCorrectionPriceIntersectionDialog],
["DialogDeleteDialog", LazyDialogDeleteDialog],
["DialogErrorDialog", LazyDialogErrorDialog],
["DialogFixPriceIntersectionDialog", LazyDialogFixPriceIntersectionDialog],
["DialogGroupTreeModal", LazyDialogGroupTreeModal],
["DialogPageDialogues", LazyDialogPageDialogues],
["DialogParamValueDialog", LazyDialogParamValueDialog],
["DialogPriceDialog", LazyDialogPriceDialog],
["DialogSelectColumns", LazyDialogSelectColumns],
["DialogSelectParametersDialog", LazyDialogSelectParametersDialog],
["DialogSelectPriceLevel", LazyDialogSelectPriceLevel],
["DialogSelectPriceType", LazyDialogSelectPriceType],
["DialogSelectRegionType", LazyDialogSelectRegionType],
["DialogSelectStockLevel", LazyDialogSelectStockLevel],
["DialogSelectTable", LazyDialogSelectTable],
["DialogTableValueDialog", LazyDialogTableValueDialog],
["DialogUploadCorrectionPriceErrorDialog", LazyDialogUploadCorrectionPriceErrorDialog],
["DialogUploadCorrectionPriceFinishDialog", LazyDialogUploadCorrectionPriceFinishDialog],
["DialogWarningParameterHasValue", LazyDialogWarningParameterHasValue],
["DialogMarketingValueTypeDialog", LazyDialogMarketingValueTypeDialog],
["DialogParamValueBoolValue", LazyDialogParamValueBoolValue],
["DialogParamValueDigitValue", LazyDialogParamValueDigitValue],
["DialogParamValueStringValue", LazyDialogParamValueStringValue],
["DialogParamValueTableValue", LazyDialogParamValueTableValue],
["EventTypeSchemaEditorArrayItem", LazyEventTypeSchemaEditorArrayItem],
["EventTypeSchemaEditorItem", LazyEventTypeSchemaEditorItem],
["EventTypeSchemaEditorObjectItem", LazyEventTypeSchemaEditorObjectItem],
["EventTypeSchemaEditorPanel", LazyEventTypeSchemaEditorPanel],
["EventTypeSchemaEditor", LazyEventTypeSchemaEditor],
["FilterParam", LazyFilterParam],
["FlowChartBlockAnchor", LazyFlowChartBlockAnchor],
["FlowChartBlockAnchorG", LazyFlowChartBlockAnchorG],
["FlowChartBlockBaseBlock", LazyFlowChartBlockBaseBlock],
["FlowChartBlockBorder", LazyFlowChartBlockBorder],
["FlowChartBlockCondition", LazyFlowChartBlockCondition],
["FlowChartBlockException", LazyFlowChartBlockException],
["FlowChartBlockFinish", LazyFlowChartBlockFinish],
["FlowChartBlockFunction", LazyFlowChartBlockFunction],
["FlowChartBlockProcess", LazyFlowChartBlockProcess],
["FlowChartBlockResult", LazyFlowChartBlockResult],
["FlowChartBlockStart", LazyFlowChartBlockStart],
["FlowChartComponentButtonClear", LazyFlowChartComponentButtonClear],
["FlowChartComponentButtonSelect", LazyFlowChartComponentButtonSelect],
["FlowChartComponentCompare", LazyFlowChartComponentCompare],
["FlowChartComponentFunction", LazyFlowChartComponentFunction],
["FlowChartComponentMessage", LazyFlowChartComponentMessage],
["FlowChartComponentVarName", LazyFlowChartComponentVarName],
["FlowChartComponentVarSource", LazyFlowChartComponentVarSource],
["FlowChartConnector", LazyFlowChartConnector],
["FlowChart", LazyFlowChart],
["FormEditor", LazyFormEditor],
["GroupList", LazyGroupList],
["GroupTree", LazyGroupTree],
["GroupTreeSelect", LazyGroupTreeSelect],
["InputParameterValueBoolean", LazyInputParameterValueBoolean],
["InputParameterValueDataTable", LazyInputParameterValueDataTable],
["InputParameterValueDateTime", LazyInputParameterValueDateTime],
["InputParameterValueDigital", LazyInputParameterValueDigital],
["InputParameterValueDigitalList", LazyInputParameterValueDigitalList],
["InputParameterValueDigitalListBox", LazyInputParameterValueDigitalListBox],
["InputParameterValuePriceLevel", LazyInputParameterValuePriceLevel],
["InputParameterValueVariable", LazyInputParameterValueVariable],
["InputParameterValueInputParameterVariable", LazyInputParameterValueInputParameterVariable],
["InputParameterValueListBox", LazyInputParameterValueListBox],
["InputParameterValuePrice", LazyInputParameterValuePrice],
["InputParameterValueRegion", LazyInputParameterValueRegion],
["InputParameterValueRegionPrice", LazyInputParameterValueRegionPrice],
["InputParameterValueStockLevel", LazyInputParameterValueStockLevel],
["InputParameterValueString", LazyInputParameterValueString],
["InputParameterValueStringList", LazyInputParameterValueStringList],
["InputParameterValueTable", LazyInputParameterValueTable],
["InputParameterValue", LazyInputParameterValue],
["JsonEditor", LazyJsonEditor],
["LeftMenuItem", LazyLeftMenuItem],
["LinkButton", LazyLinkButton],
["LoyaltyAlgorithmEditorBlockResult", LazyLoyaltyAlgorithmEditorBlockResult],
["LoyaltyAlgorithmEditorDialogSelectOutParam", LazyLoyaltyAlgorithmEditorDialogSelectOutParam],
["LoyaltyAlgorithmEditorDialogSelectValue", LazyLoyaltyAlgorithmEditorDialogSelectValue],
["MarketingAlgorithmEditorDialogSelectResult", LazyMarketingAlgorithmEditorDialogSelectResult],
["MarketingAlgorithmEditorDialogSelectValue", LazyMarketingAlgorithmEditorDialogSelectValue],
["MarketingConditionAlgorithmEditorDialogSelectValue", LazyMarketingConditionAlgorithmEditorDialogSelectValue],
["PagesBaseTaskPage", LazyPagesBaseTaskPage],
["ParamSearchPanel", LazyParamSearchPanel],
["ParamValuePanel", LazyParamValuePanel],
["ParamValueProductPanel", LazyParamValueProductPanel],
["ParameterTypeBoolean", LazyParameterTypeBoolean],
["ParameterTypeDecimal", LazyParameterTypeDecimal],
["ParameterTypeList", LazyParameterTypeList],
["ParameterTypePercent", LazyParameterTypePercent],
["ParameterTypeString", LazyParameterTypeString],
["ParameterTypeTable", LazyParameterTypeTable],
["ParameterValueTable", LazyParameterValueTable],
["PriceLevelRule", LazyPriceLevelRule],
["PriceLevel", LazyPriceLevel],
["PriceRegionGroupFilter", LazyPriceRegionGroupFilter],
["ProductDistributionRulesBlock", LazyProductDistributionRulesBlock],
["ProductDistributionRulesCondition", LazyProductDistributionRulesCondition],
["ProductDistributionRulesItem", LazyProductDistributionRulesItem],
["ProductDistributionRules", LazyProductDistributionRules],
["ProviderRuleCondition", LazyProviderRuleCondition],
["ProviderRuleDialogSelect", LazyProviderRuleDialogSelect],
["ProviderRuleGroup", LazyProviderRuleGroup],
["ProviderRuleItem", LazyProviderRuleItem],
["ProviderRule", LazyProviderRule],
["ResultEditorArrayItem", LazyResultEditorArrayItem],
["ResultEditorItem", LazyResultEditorItem],
["ResultEditorObjectItem", LazyResultEditorObjectItem],
["ResultEditorPanel", LazyResultEditorPanel],
["ResultEditor", LazyResultEditor],
["RichTable", LazyRichTable],
["RoomEditor", LazyRoomEditor],
["SearchControl", LazySearchControl],
["SearchFilterItem", LazySearchFilterItem],
["SearchFilterPopover", LazySearchFilterPopover],
["SearchPanelFieldAllocationRule", LazySearchPanelFieldAllocationRule],
["SearchPanelFieldBoolean", LazySearchPanelFieldBoolean],
["SearchPanelFieldCardType", LazySearchPanelFieldCardType],
["SearchPanelFieldCode", LazySearchPanelFieldCode],
["SearchPanelFieldConcurrent", LazySearchPanelFieldConcurrent],
["SearchPanelFieldConcurrentPriceTypeName", LazySearchPanelFieldConcurrentPriceTypeName],
["SearchPanelFieldConcurrentProductStatus", LazySearchPanelFieldConcurrentProductStatus],
["SearchPanelFieldConcurrentProductStatusName", LazySearchPanelFieldConcurrentProductStatusName],
["SearchPanelFieldConcurrentRegionName", LazySearchPanelFieldConcurrentRegionName],
["SearchPanelFieldDate", LazySearchPanelFieldDate],
["SearchPanelFieldGroup", LazySearchPanelFieldGroup],
["SearchPanelFieldGroupType", LazySearchPanelFieldGroupType],
["SearchPanelFieldID", LazySearchPanelFieldID],
["SearchPanelFieldNumber", LazySearchPanelFieldNumber],
["SearchPanelFieldParamType", LazySearchPanelFieldParamType],
["SearchPanelFieldPolitic", LazySearchPanelFieldPolitic],
["SearchPanelFieldPriceType", LazySearchPanelFieldPriceType],
["SearchPanelFieldPriceTypeGroup", LazySearchPanelFieldPriceTypeGroup],
["SearchPanelFieldProduct", LazySearchPanelFieldProduct],
["SearchPanelFieldRegionGroup", LazySearchPanelFieldRegionGroup],
["SearchPanelFieldRegionType", LazySearchPanelFieldRegionType],
["SearchPanelFieldScope", LazySearchPanelFieldScope],
["SearchPanelFieldShop", LazySearchPanelFieldShop],
["SearchPanelFieldShowcase", LazySearchPanelFieldShowcase],
["SearchPanelFieldShowcaseCategory", LazySearchPanelFieldShowcaseCategory],
["SearchPanelFieldShowcaseModuleType", LazySearchPanelFieldShowcaseModuleType],
["SearchPanelFieldShowcaseType", LazySearchPanelFieldShowcaseType],
["SearchPanelFieldShowcaseTypeModuleTemplate", LazySearchPanelFieldShowcaseTypeModuleTemplate],
["SearchPanelFieldStock", LazySearchPanelFieldStock],
["SearchPanelFieldString", LazySearchPanelFieldString],
["SearchPanelFieldSupplier", LazySearchPanelFieldSupplier],
["SearchPanelFieldUser", LazySearchPanelFieldUser],
["SearchPanelFilter", LazySearchPanelFilter],
["SearchPanel", LazySearchPanel],
["ShowcasePlanogram", LazyShowcasePlanogram],
["ShowсaseTemplateEditor", LazyShowсaseTemplateEditor],
["StockLevelRule", LazyStockLevelRule],
["StockLevel", LazyStockLevel],
["StockSuppliersItem", LazyStockSuppliersItem],
["StockSuppliers", LazyStockSuppliers],
["TabButtonControl", LazyTabButtonControl],
["TabButtonPanel", LazyTabButtonPanel],
["TabButton", LazyTabButton],
["Task", LazyTask],
["TaskEditor", LazyTaskEditor],
["TimeSelectorPanel", LazyTimeSelectorPanel],
["TimeSelectorConsts", LazyTimeSelectorConsts],
["TimeSelector", LazyTimeSelector],
["TitlePageControlFooter", LazyTitlePageControlFooter],
["TitlePageControl", LazyTitlePageControl],
["TriggerMapping", LazyTriggerMapping],
["TriggerMappingItem", LazyTriggerMappingItem],
["ValueField", LazyValueField],
["VariableEditorArrayItem", LazyVariableEditorArrayItem],
["VariableEditorItem", LazyVariableEditorItem],
["VariableEditorObjectItem", LazyVariableEditorObjectItem],
["VariableEditorPanel", LazyVariableEditorPanel],
["VariableEditor", LazyVariableEditor],
["VariableValuePanel", LazyVariableValuePanel],
["TableValueListLimit", LazyTableValueListLimit],
["TableValueRangeLimit", LazyTableValueRangeLimit],
["TableValueWithoutLimit", LazyTableValueWithoutLimit],
["ValueListItem", LazyValueListItem],
["ValueListPanel", LazyValueListPanel],
["UAccordion", LazyUAccordion],
["UAlert", LazyUAlert],
["UAvatar", LazyUAvatar],
["UAvatarGroup", LazyUAvatarGroup],
["UBadge", LazyUBadge],
["UButton", LazyUButton],
["UButtonGroup", LazyUButtonGroup],
["UCarousel", LazyUCarousel],
["UChip", LazyUChip],
["UDropdown", LazyUDropdown],
["UIcon", LazyUIcon],
["UKbd", LazyUKbd],
["ULink", LazyULink],
["UMeter", LazyUMeter],
["UMeterGroup", LazyUMeterGroup],
["UProgress", LazyUProgress],
["UCheckbox", LazyUCheckbox],
["UForm", LazyUForm],
["UFormGroup", LazyUFormGroup],
["UInput", LazyUInput],
["UInputMenu", LazyUInputMenu],
["URadio", LazyURadio],
["URadioGroup", LazyURadioGroup],
["URange", LazyURange],
["USelect", LazyUSelect],
["USelectMenu", LazyUSelectMenu],
["UTextarea", LazyUTextarea],
["UToggle", LazyUToggle],
["UTable", LazyUTable],
["UCard", LazyUCard],
["UContainer", LazyUContainer],
["UDivider", LazyUDivider],
["USkeleton", LazyUSkeleton],
["UBreadcrumb", LazyUBreadcrumb],
["UCommandPalette", LazyUCommandPalette],
["UCommandPaletteGroup", LazyUCommandPaletteGroup],
["UHorizontalNavigation", LazyUHorizontalNavigation],
["UPagination", LazyUPagination],
["UTabs", LazyUTabs],
["UVerticalNavigation", LazyUVerticalNavigation],
["UContextMenu", LazyUContextMenu],
["UModal", LazyUModal],
["UModals", LazyUModals],
["UNotification", LazyUNotification],
["UNotifications", LazyUNotifications],
["UPopover", LazyUPopover],
["USlideover", LazyUSlideover],
["USlideovers", LazyUSlideovers],
["UTooltip", LazyUTooltip],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
